export {
  StatusBadge as default,
  StatusBadge,
  type StatusBadgeShape,
  type StatusBadgeTone,
  type StatusBadgeType,
} from "@louise/moon-ui";
